<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('organizations')">Empresa</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore">
      This organization has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ruc" :error="form.errors.ruc" class="pr-6 pb-8 w-full lg:w-2/6" label="Ruc" />
          <text-input v-model="form.tradename" :error="form.errors.tradename" class="pr-6 pb-8 w-full lg:w-2/6" label="Nombre Comercial" />
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/6" label="Nombre" />
          <text-input v-model="form.representation" :error="form.errors.representation" class="pr-6 pb-8 w-full lg:w-2/6" label="Representante Legal" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-2/6" label="Email" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-2/6" label="Phone" />
          <select-input v-model="form.city_id" :error="form.errors.city_id" class="pr-6 pb-8 w-full lg:w-2/6" label="Provincia">
            <option v-for="city in cities" :key="city.id" :value="form.city_id">{{ city.name}}</option>
          </select-input>
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-4/6" label="Address" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!organization.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Empresa</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    organization: Object,
    cities: Array,
  },
  remember: 'form',
  data() {
    return {
      cities: this.cities,
      form: this.$inertia.form({
        name: this.organization.name,
        ruc: this.organization.ruc,
        tradename: this.organization.tradename,
        email: this.organization.email,
        phone: this.organization.phone,
        address: this.organization.address,
        city: this.organization.city,
        representation: this.organization.representation,
        city_id: this.organization.city_id,
        postal_code: this.organization.postal_code,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('organizations.update', this.organization.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.delete(this.route('organizations.destroy', this.organization.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(this.route('organizations.restore', this.organization.id))
      }
    },
  },
}
</script>
